<template lang="pug">
.row
  .col-sm-12.basic-filters
    label {{ projectLabel }}
    AppSelect(
      v-model="selected"
      :options="projects"
      :select2-options="select2Options"
      async
    )
</template>

<script>
import { mapGetters } from 'vuex';
import { getProjectFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'ActivitiesProjectFilter',
  computed: {
    ...mapGetters(['queryFilters', 'projects', 'organizationProjectFlavour']),
    selected: {
      get() {
        return this.queryFilters.project;
      },
      set(project) {
        this.$store.dispatch('setFilter', { project });
      },
    },
    select2Options() {
      return {
        allowClear: true,
        multiple: false,
        placeholder: `All ${this.projectLabelPlural.toLowerCase()}`,
        width: '100%',
      };
    },
    projectLabel() {
      return getProjectFlavourLabel(this.organizationProjectFlavour);
    },
    projectLabelPlural() {
      return getProjectFlavourLabel(this.organizationProjectFlavour, true);
    },
  },
};
</script>
